"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _pagesHeader = _interopRequireDefault(require("@/components/base/pagesHeader"));
var marketApi = _interopRequireWildcard(require("@/api/market"));
var _system = require("@/api/system");
var _permission = require("@/utils/permission");
var _lifeVibesPoint = require("@/api/lifeVibesPoint");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* global TMap */
var _default = exports.default = {
  name: 'LifeVibesPointForm',
  components: {
    PagesHeader: _pagesHeader.default
  },
  data: function data() {
    var _this2 = this;
    var validateCoordinate = function validateCoordinate(rule, value, callback) {
      if (!value && value !== 0) {
        callback(new Error(rule.field === 'lng' ? '请选择经度' : '请选择纬度'));
        return;
      }
      callback();
    };
    var validateMarketId = function validateMarketId(rule, value, callback) {
      if (_this2.isMarketBindingMode && !value) {
        callback(new Error('请选择关联集市'));
        return;
      }
      callback();
    };
    var validatePointImages = function validatePointImages(rule, value, callback) {
      if (!Array.isArray(value) || value.length === 0) {
        callback(new Error('请至少上传一张点位图片'));
        return;
      }
      callback();
    };
    return {
      isEdit: false,
      submitLoading: false,
      marketLoading: false,
      regionLoading: false,
      marketOptions: [],
      regionOptions: [],
      selectedRegion: [],
      regionProps: {
        value: 'code',
        label: 'name',
        children: 'children',
        emitPath: true,
        checkStrictly: false
      },
      pointTypeOptions: [{
        label: '集市',
        value: 0
      }, {
        label: '展会地点',
        value: 1
      }, {
        label: '预留',
        value: 2
      }, {
        label: '打野地点',
        value: 3
      }],
      form: this.getDefaultForm(),
      rules: {
        pointImg: [{
          validator: validatePointImages,
          trigger: 'change'
        }],
        pointName: [{
          required: true,
          message: '请输入点位名称',
          trigger: 'blur'
        }],
        pointType: [{
          required: true,
          message: '请选择点位类型',
          trigger: 'change'
        }],
        merchantStatus: [{
          required: true,
          message: '请选择认证状态',
          trigger: 'change'
        }],
        marketId: [{
          validator: validateMarketId,
          trigger: 'change'
        }],
        location: [{
          required: true,
          message: '请填写或带入详细地点',
          trigger: 'change'
        }],
        lng: [{
          validator: validateCoordinate,
          trigger: 'change'
        }],
        lat: [{
          validator: validateCoordinate,
          trigger: 'change'
        }]
      },
      mapDialogVisible: false,
      searchResults: [],
      selectedSearchResult: null,
      searchLoading: false,
      searchNoDataText: '请输入地点名称搜索',
      currentSearchKeyword: '',
      currentPage: 1,
      pageSize: 20,
      hasMoreResults: false,
      loadingMore: false,
      tagInputValue: '',
      currentCity: '',
      selectedAddress: '',
      selectedLocationName: '',
      selectedLng: '',
      selectedLat: '',
      selectedAddressDetail: null,
      tencentMap: null,
      tencentMarker: null,
      geolocationInstance: null,
      mapEventsBound: false
    };
  },
  computed: {
    pageTitle: function pageTitle() {
      return this.isEdit ? '编辑烟火点位' : '新增烟火点位';
    },
    hasSubmitPermission: function hasSubmitPermission() {
      if (this.isEdit) {
        return (0, _permission.checkPermi)(['platform:lifeVibesPoint:update']);
      }
      return (0, _permission.checkPermi)(['platform:lifeVibesPoint:save']);
    },
    isMarketBindingMode: function isMarketBindingMode() {
      return Number(this.form.pointType) === 0 && Number(this.form.merchantStatus) === 1;
    }
  },
  created: function created() {
    this.loadRegionData();
    var id = this.$route.query.id;
    if (id) {
      this.isEdit = true;
      this.loadDetail(id);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.cleanupMapSelection();
  },
  methods: {
    getDefaultForm: function getDefaultForm() {
      return {
        id: null,
        pointImg: [],
        pointName: '',
        content: '',
        tags: [],
        readCount: 0,
        pointType: 0,
        merchantStatus: 0,
        marketId: '',
        province: '',
        provinceCode: '',
        city: '',
        cityCode: '',
        district: '',
        districtCode: '',
        location: '',
        lng: '',
        lat: '',
        createTime: '',
        updateTime: ''
      };
    },
    getImageList: function getImageList(imageValue) {
      if (!imageValue) return [];
      if (Array.isArray(imageValue)) return imageValue.filter(Boolean);
      if (typeof imageValue === 'string') {
        try {
          var parsed = JSON.parse(imageValue);
          if (Array.isArray(parsed)) return parsed.filter(Boolean);
        } catch (error) {
          var commaList = imageValue.split(',').map(function (item) {
            return item.trim();
          }).filter(Boolean);
          if (commaList.length > 1) return commaList;
        }
        return [imageValue];
      }
      return [];
    },
    stringifyImageList: function stringifyImageList(list) {
      var images = Array.isArray(list) ? list.filter(Boolean) : [];
      return images.length ? JSON.stringify(images) : '';
    },
    normalizeTags: function normalizeTags(tags) {
      return this.parseTags(tags).join(',');
    },
    parseTags: function parseTags(tags) {
      if (!tags) return [];
      if (Array.isArray(tags)) {
        return tags.map(function (item) {
          return String(item).trim();
        }).filter(Boolean).filter(function (item, index, arr) {
          return arr.indexOf(item) === index;
        }).slice(0, 20);
      }
      return String(tags).split(/[,，\n]/).map(function (item) {
        return item.trim();
      }).filter(Boolean).filter(function (item, index, arr) {
        return arr.indexOf(item) === index;
      }).slice(0, 20);
    },
    extractRegionCode: function extractRegionCode(code) {
      if (code === null || code === undefined || code === '') return '';
      var match = String(code).match(/(\d{6})$/);
      return match ? Number(match[1]) : Number(code);
    },
    formatCoordinate: function formatCoordinate(value) {
      if (value === null || value === undefined || value === '') return '';
      var numberValue = Number(value);
      return Number.isNaN(numberValue) ? String(value) : numberValue.toFixed(6);
    },
    loadRegionData: function loadRegionData() {
      var _this3 = this;
      this.regionLoading = true;
      (0, _system.cityListApi)().then(function (res) {
        _this3.regionOptions = res || [];
        _this3.syncSelectedRegionFromForm();
        _this3.regionLoading = false;
      }).catch(function () {
        _this3.regionLoading = false;
        _this3.$message.error('加载省市区数据失败');
      });
    },
    normalizeNumberValue: function normalizeNumberValue(value) {
      if (value === '' || value === null || value === undefined) return '';
      var numberValue = Number(value);
      return Number.isNaN(numberValue) ? '' : numberValue;
    },
    loadDetail: function loadDetail(id) {
      var _this4 = this;
      (0, _lifeVibesPoint.lifeVibesPointInfo)(id).then(function (res) {
        var formData = Object.assign(_this4.getDefaultForm(), res || {});
        formData.pointImg = _this4.getImageList(formData.pointImg);
        formData.tags = _this4.parseTags(formData.tags);
        formData.lng = _this4.formatCoordinate(formData.lng);
        formData.lat = _this4.formatCoordinate(formData.lat);
        if (Number(formData.pointType) === 0 && Number(formData.merchantStatus) > 1) {
          formData.marketId = Number(formData.merchantStatus);
          formData.merchantStatus = 1;
          _this4.loadMarketOptions();
        }
        _this4.form = formData;
        _this4.syncCurrentCity();
        _this4.syncSelectedRegionFromForm();
      });
    },
    buildSubmitData: function buildSubmitData() {
      var submitData = _objectSpread(_objectSpread({}, this.form), {}, {
        tags: this.normalizeTags(this.form.tags),
        readCount: Number(this.form.readCount || 0),
        pointImg: this.stringifyImageList(this.form.pointImg),
        lng: this.normalizeNumberValue(this.form.lng),
        lat: this.normalizeNumberValue(this.form.lat),
        provinceCode: this.normalizeNumberValue(this.form.provinceCode),
        cityCode: this.normalizeNumberValue(this.form.cityCode),
        districtCode: this.normalizeNumberValue(this.form.districtCode)
      });
      if (this.isMarketBindingMode) {
        submitData.marketId = Number(this.form.marketId);
        submitData.merchantStatus = Number(this.form.marketId);
      } else {
        submitData.merchantStatus = Number(this.form.merchantStatus);
        delete submitData.marketId;
      }
      return submitData;
    },
    handleSubmit: function handleSubmit() {
      var _this5 = this;
      if (!this.hasSubmitPermission) {
        this.$message.error('当前账号没有提交权限');
        return;
      }
      this.$refs.formRef.validate(function (valid) {
        if (!valid) return;
        _this5.submitLoading = true;
        var submitData = _this5.buildSubmitData();
        var request = _this5.isEdit ? (0, _lifeVibesPoint.lifeVibesPointUpdate)(submitData) : (0, _lifeVibesPoint.lifeVibesPointSave)(submitData);
        request.then(function () {
          _this5.$message.success(_this5.isEdit ? '修改成功' : '新增成功');
          _this5.submitLoading = false;
          _this5.$router.push({
            path: '/market/life-vibes-point'
          });
        }).catch(function () {
          _this5.submitLoading = false;
        });
      });
    },
    handleCancel: function handleCancel() {
      this.$router.push({
        path: '/market/life-vibes-point'
      });
    },
    uploadPointImage: function uploadPointImage() {
      var _this = this;
      this.$modalUpload(function (imgs) {
        if (!imgs || !imgs.length) return;
        var urls = imgs.map(function (item) {
          return item && (item.sattDir || item.url || item.path || '');
        }).filter(Boolean);
        var remain = 9 - _this.form.pointImg.length;
        _this.form.pointImg = _this.form.pointImg.concat(urls.slice(0, remain));
        _this.$refs.formRef && _this.$refs.formRef.validateField('pointImg');
        if (urls.length > remain) {
          _this.$message.warning("\u6700\u591A\u4E0A\u4F20 9 \u5F20\u56FE\u7247\uFF0C\u5DF2\u4E3A\u4F60\u4FDD\u7559\u524D ".concat(remain, " \u5F20"));
        }
      }, 'pointImg', 'selfUpload', {
        multiple: true,
        maxCount: 9
      });
    },
    removePointImage: function removePointImage(index) {
      this.form.pointImg.splice(index, 1);
      this.$refs.formRef && this.$refs.formRef.validateField('pointImg');
    },
    handleTagInputConfirm: function handleTagInputConfirm() {
      var value = this.tagInputValue.trim();
      if (!value) return;
      if (this.form.tags.includes(value)) {
        this.$message.warning('该标签已存在');
        this.tagInputValue = '';
        return;
      }
      if (this.form.tags.length >= 20) {
        this.$message.warning('最多添加 20 个标签');
        return;
      }
      this.form.tags.push(value);
      this.tagInputValue = '';
    },
    removeTag: function removeTag(index) {
      this.form.tags.splice(index, 1);
    },
    syncCurrentCity: function syncCurrentCity() {
      this.currentCity = this.form.city || this.form.province || '';
    },
    handleRegionChange: function handleRegionChange(values) {
      if (!values || !values.length) {
        this.form.province = '';
        this.form.city = '';
        this.form.district = '';
        this.form.provinceCode = '';
        this.form.cityCode = '';
        this.form.districtCode = '';
        this.syncCurrentCity();
        return;
      }
      if (values.length !== 3) return;
      var regionNodes = this.getRegionNodesByValues(values);
      this.form.province = regionNodes[0] ? regionNodes[0].name || '' : '';
      this.form.city = regionNodes[1] ? regionNodes[1].name || '' : '';
      this.form.district = regionNodes[2] ? regionNodes[2].name || '' : '';
      this.form.provinceCode = regionNodes[0] ? this.extractRegionCode(regionNodes[0].code) : '';
      this.form.cityCode = regionNodes[1] ? this.extractRegionCode(regionNodes[1].code) : '';
      this.form.districtCode = regionNodes[2] ? this.extractRegionCode(regionNodes[2].code) : '';
      this.syncCurrentCity();
    },
    getRegionNodesByValues: function getRegionNodesByValues(values) {
      var _this6 = this;
      var matchedNodes = [];
      var currentNodes = this.regionOptions;
      (values || []).forEach(function (value) {
        var matchedNode = (currentNodes || []).find(function (item) {
          return item.code === value || _this6.extractRegionCode(item.code) === _this6.extractRegionCode(value);
        });
        if (matchedNode) {
          matchedNodes.push(matchedNode);
          currentNodes = matchedNode.children || [];
        }
      });
      return matchedNodes;
    },
    findRegionNode: function findRegionNode(nodes, code, name) {
      var _this7 = this;
      if (!Array.isArray(nodes) || !nodes.length) return null;
      var normalizedCode = this.extractRegionCode(code);
      return nodes.find(function (item) {
        var itemCode = _this7.extractRegionCode(item.code);
        return normalizedCode !== '' && itemCode === normalizedCode || name && item.name === name;
      }) || null;
    },
    syncSelectedRegionFromForm: function syncSelectedRegionFromForm() {
      if (!this.regionOptions.length) return;
      var provinceNode = this.findRegionNode(this.regionOptions, this.form.provinceCode, this.form.province);
      if (!provinceNode) {
        this.selectedRegion = [];
        return;
      }
      var selectedValues = [provinceNode.code];
      var cityNode = this.findRegionNode(provinceNode.children || [], this.form.cityCode, this.form.city);
      if (cityNode) {
        selectedValues.push(cityNode.code);
        var districtNode = this.findRegionNode(cityNode.children || [], this.form.districtCode, this.form.district);
        if (districtNode) {
          selectedValues.push(districtNode.code);
        }
      }
      this.selectedRegion = selectedValues;
    },
    handlePointTypeChange: function handlePointTypeChange() {
      if (Number(this.form.pointType) !== 0) {
        this.form.marketId = '';
      } else if (this.isMarketBindingMode) {
        this.loadMarketOptions();
      }
    },
    handleMerchantStatusChange: function handleMerchantStatusChange() {
      if (!this.isMarketBindingMode) {
        this.form.marketId = '';
      } else {
        this.loadMarketOptions();
      }
    },
    loadMarketOptions: function loadMarketOptions() {
      var _this8 = this;
      if (this.marketOptions.length || this.marketLoading) return;
      this.marketLoading = true;
      marketApi.marketList({
        page: 1,
        limit: 10000
      }).then(function (res) {
        var list = res && res.list ? res.list : Array.isArray(res) ? res : [];
        _this8.marketOptions = list.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            id: item.id,
            marketName: item.marketName || item.name || "\u96C6\u5E02".concat(item.id)
          });
        });
        _this8.marketLoading = false;
      }).catch(function () {
        _this8.marketLoading = false;
      });
    },
    handleMarketChange: function handleMarketChange(value) {
      if (!value) return;
      this.fillLocationByMarketId(value);
    },
    fillLocationByMarketId: function fillLocationByMarketId(marketId) {
      var _this9 = this;
      marketApi.marketInfo(marketId).then(function (info) {
        var marketData = info || {};
        _this9.form.location = marketData.detail || marketData.street || '';
        _this9.form.lng = _this9.formatCoordinate(marketData.longitude || marketData.lng);
        _this9.form.lat = _this9.formatCoordinate(marketData.latitude || marketData.lat);
        _this9.form.province = marketData.province || '';
        _this9.form.city = marketData.city || '';
        _this9.form.district = marketData.district || '';
        _this9.form.provinceCode = _this9.extractRegionCode(marketData.provinceCode || marketData.provinceId || '');
        _this9.form.cityCode = _this9.extractRegionCode(marketData.cityCode || marketData.cityId || '');
        _this9.form.districtCode = _this9.extractRegionCode(marketData.districtCode || marketData.districtId || '');
        _this9.syncCurrentCity();
        _this9.syncSelectedRegionFromForm();
        _this9.$refs.formRef && _this9.$refs.formRef.clearValidate(['marketId', 'location', 'lng', 'lat']);
      });
    },
    openMapDialog: function openMapDialog() {
      var _this0 = this;
      if (this.isMarketBindingMode) {
        this.$message.info('当前已选择集市，地址与坐标将自动同步，不能手动地图选点');
        return;
      }
      if (this.form.lng && this.form.lat) {
        this.selectedLng = this.formatCoordinate(this.form.lng);
        this.selectedLat = this.formatCoordinate(this.form.lat);
        this.selectedAddress = this.form.location;
        this.selectedLocationName = this.form.pointName;
      } else {
        this.selectedLng = '';
        this.selectedLat = '';
        this.selectedAddress = '';
        this.selectedLocationName = '';
        this.selectedAddressDetail = null;
      }
      this.mapDialogVisible = true;
      this.$nextTick(function () {
        setTimeout(function () {
          _this0.loadTencentMapAPI();
        }, 300);
      });
    },
    handleMapDialogClose: function handleMapDialogClose() {
      this.mapDialogVisible = false;
      this.cleanupMapSelection();
    },
    cleanupMapSelection: function cleanupMapSelection() {
      this.searchResults = [];
      this.selectedSearchResult = null;
      this.searchLoading = false;
      this.searchNoDataText = '请输入地点名称搜索';
      this.currentSearchKeyword = '';
      this.currentPage = 1;
      this.hasMoreResults = false;
      this.loadingMore = false;
    },
    loadTencentMapAPI: function loadTencentMapAPI() {
      var _this1 = this;
      if (typeof TMap !== 'undefined') {
        setTimeout(function () {
          _this1.initTencentMap();
        }, 300);
        return;
      }
      var script = document.createElement('script');
      script.src = "https://map.qq.com/api/gljs?v=1.exp&key=".concat(process.env.VUE_APP_TENCENT_MAP_KEY);
      script.onload = function () {
        setTimeout(function () {
          _this1.initTencentMap();
        }, 500);
      };
      script.onerror = function () {
        _this1.$message.error('地图 API 加载失败，请检查网络连接');
      };
      document.head.appendChild(script);
    },
    initTencentMap: function initTencentMap() {
      if (typeof TMap === 'undefined') {
        this.$message.error('地图 API 未加载，请刷新后重试');
        return;
      }
      if (!this.tencentMap) {
        this.tencentMap = new TMap.Map('lifeVibesMapContainer', {
          center: new TMap.LatLng(39.9042, 116.4074),
          zoom: 10
        });
      }
      if (this.form.lng && this.form.lat) {
        var lng = Number(this.form.lng);
        var lat = Number(this.form.lat);
        this.tencentMap.setCenter(new TMap.LatLng(lat, lng));
        this.tencentMap.setZoom(15);
        this.selectedLng = this.formatCoordinate(lng);
        this.selectedLat = this.formatCoordinate(lat);
        this.selectedAddress = this.form.location;
        this.selectedLocationName = this.form.pointName;
        this.currentCity = this.form.city || this.form.province || '';
        this.addMarker(lng, lat);
      } else {
        this.tencentMap.setCenter(new TMap.LatLng(39.9042, 116.4074));
        this.tencentMap.setZoom(10);
        this.selectedLng = '';
        this.selectedLat = '';
        this.selectedAddress = '';
        this.selectedLocationName = '';
        this.selectedAddressDetail = null;
      }
      this.bindMapEvents();
    },
    bindMapEvents: function bindMapEvents() {
      if (!this.tencentMap || this.mapEventsBound) return;
      this.tencentMap.on('click', this.onMapClick);
      this.mapEventsBound = true;
    },
    onMapClick: function onMapClick(e) {
      var lng;
      var lat;
      if (e.latLng && e.latLng.lng !== undefined && e.latLng.lat !== undefined) {
        lng = e.latLng.lng;
        lat = e.latLng.lat;
      } else if (e.lnglat && e.lnglat.lng !== undefined && e.lnglat.lat !== undefined) {
        lng = e.lnglat.lng;
        lat = e.lnglat.lat;
      } else if (e.lng !== undefined && e.lat !== undefined) {
        lng = e.lng;
        lat = e.lat;
      }
      if (e.poi && e.poi.latLng) {
        lng = e.poi.latLng.lng;
        lat = e.poi.latLng.lat;
      }
      if (lng === undefined || lat === undefined) {
        this.$message.error('无法获取点击位置坐标');
        return;
      }
      this.selectedLng = Number(lng).toFixed(6);
      this.selectedLat = Number(lat).toFixed(6);
      this.addMarker(lng, lat);
      this.reverseGeocode(lng, lat);
    },
    addMarker: function addMarker(lng, lat) {
      var _this10 = this;
      this.$nextTick(function () {
        if (_this10.tencentMarker) {
          _this10.tencentMarker.setMap(null);
        }
        _this10.tencentMarker = new TMap.MultiMarker({
          map: _this10.tencentMap,
          geometries: [{
            id: 'marker',
            position: new TMap.LatLng(lat, lng),
            styleId: 'marker'
          }]
        });
      });
    },
    reverseGeocode: function reverseGeocode(lng, lat) {
      var _this11 = this;
      var apiUrl = 'https://apis.map.qq.com/ws/geocoder/v1/';
      var params = new URLSearchParams({
        location: "".concat(lat, ",").concat(lng),
        key: process.env.VUE_APP_TENCENT_MAP_KEY,
        get_poi: '1',
        output: 'jsonp'
      });
      var callbackName = "qqMapReverseCallback_".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 9));
      params.append('callback', callbackName);
      window[callbackName] = function (data) {
        try {
          if (data.status === 0 && data.result) {
            var resultData = data.result;
            var comp = resultData.address_component || {};
            var address = resultData.formatted_addresses ? resultData.formatted_addresses.standard_address + (resultData.formatted_addresses.recommend || resultData.formatted_addresses.rough || '') : resultData.address || "\u5750\u6807\u4F4D\u7F6E (".concat(Number(lng).toFixed(6), ", ").concat(Number(lat).toFixed(6), ")");
            _this11.selectedAddress = address;
            _this11.selectedLocationName = resultData.title || '';
            _this11.selectedAddressDetail = {
              addressComponent: comp,
              address: resultData.address || '',
              formattedAddress: address
            };
            _this11.currentCity = comp.city || comp.province || _this11.currentCity;
          } else {
            _this11.selectedAddress = "\u5750\u6807\u4F4D\u7F6E (".concat(Number(lng).toFixed(6), ", ").concat(Number(lat).toFixed(6), ")");
            _this11.selectedAddressDetail = null;
          }
        } finally {
          _this11.cleanupJsonp(callbackName);
        }
      };
      var script = document.createElement('script');
      script.src = "".concat(apiUrl, "?").concat(params.toString());
      script.onerror = function () {
        _this11.selectedAddress = "\u5750\u6807\u4F4D\u7F6E (".concat(Number(lng).toFixed(6), ", ").concat(Number(lat).toFixed(6), ")");
        _this11.selectedAddressDetail = null;
        _this11.cleanupJsonp(callbackName);
      };
      document.head.appendChild(script);
    },
    cleanupJsonp: function cleanupJsonp(callbackName) {
      if (window[callbackName]) {
        delete window[callbackName];
      }
      var scripts = document.querySelectorAll("script[src*=\"".concat(callbackName, "\"]"));
      scripts.forEach(function (script) {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    },
    confirmLocation: function confirmLocation() {
      var _this12 = this;
      if (!this.selectedAddress) {
        this.$message.warning('请先在地图上选择位置');
        return;
      }
      var comp = this.selectedAddressDetail && this.selectedAddressDetail.addressComponent || {};
      this.form.location = this.selectedAddress;
      this.form.lng = this.selectedLng;
      this.form.lat = this.selectedLat;
      this.form.province = comp.province || '';
      this.form.city = comp.city || '';
      this.form.district = comp.district || comp.county || '';
      this.form.provinceCode = this.extractRegionCode(comp.province_code || comp.adcode || '');
      this.form.cityCode = this.extractRegionCode(comp.city_code || comp.adcode || '');
      this.form.districtCode = this.extractRegionCode(comp.district_code || comp.county_code || comp.adcode || '');
      this.syncCurrentCity();
      this.syncSelectedRegionFromForm();
      this.mapDialogVisible = false;
      this.$nextTick(function () {
        _this12.$refs.formRef.clearValidate(['location', 'lng', 'lat']);
      });
      this.cleanupMapSelection();
    },
    searchLocation: function searchLocation(query) {
      if (!query || !query.trim()) {
        this.searchResults = [];
        this.searchNoDataText = '请输入地点名称搜索';
        this.currentSearchKeyword = '';
        return;
      }
      this.currentSearchKeyword = query.trim();
      this.currentPage = 1;
      this.searchResults = [];
      this.hasMoreResults = false;
      this.searchLoading = true;
      this.searchNoDataText = '搜索中...';
      this.performSearch(this.currentSearchKeyword);
    },
    performSearch: function performSearch(query) {
      var _this13 = this;
      var boundaryCity = this.currentCity || this.form.city || this.form.province || '北京';
      var apiUrl = 'https://apis.map.qq.com/ws/place/v1/search';
      var params = new URLSearchParams({
        keyword: query,
        boundary: "region(".concat(boundaryCity, ",0)"),
        page_size: String(this.pageSize),
        page_index: String(this.currentPage),
        key: process.env.VUE_APP_TENCENT_MAP_KEY,
        output: 'jsonp'
      });
      var callbackName = "qqMapSearchCallback_".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 9));
      params.append('callback', callbackName);
      window[callbackName] = function (data) {
        try {
          _this13.handleSearchAPIResponse(data);
        } finally {
          _this13.cleanupJsonp(callbackName);
        }
      };
      var script = document.createElement('script');
      script.src = "".concat(apiUrl, "?").concat(params.toString());
      script.onerror = function () {
        _this13.searchLoading = false;
        _this13.loadingMore = false;
        _this13.searchNoDataText = '搜索失败，请重试';
        _this13.cleanupJsonp(callbackName);
      };
      document.head.appendChild(script);
    },
    handleSearchAPIResponse: function handleSearchAPIResponse(data) {
      var pois = data && data.data ? data.data : [];
      var newResults = (pois || []).map(function (poi) {
        return {
          name: poi.title || poi.name,
          address: poi.address,
          lng: poi.location ? poi.location.lng : 0,
          lat: poi.location ? poi.location.lat : 0
        };
      });
      if (this.currentPage === 1) {
        this.searchResults = newResults;
      } else {
        this.searchResults = this.searchResults.concat(newResults);
      }
      this.hasMoreResults = newResults.length === this.pageSize;
      this.searchLoading = false;
      this.loadingMore = false;
      this.searchNoDataText = this.searchResults.length ? '暂无更多数据' : '未找到相关地点，请尝试其他关键词';
    },
    handleSearchResultChange: function handleSearchResultChange(result) {
      if (result && result.lng && result.lat) {
        this.selectSearchResult(result);
      }
    },
    handleSelectVisibleChange: function handleSelectVisibleChange(visible) {
      if (!visible) {
        this.selectedSearchResult = null;
      }
    },
    selectSearchResult: function selectSearchResult(result) {
      if (!this.tencentMap) return;
      this.tencentMap.setCenter(new TMap.LatLng(result.lat, result.lng));
      this.tencentMap.setZoom(15);
      this.selectedLocationName = result.name;
      this.selectedAddress = result.address || result.name;
      this.selectedLng = Number(result.lng).toFixed(6);
      this.selectedLat = Number(result.lat).toFixed(6);
      this.addMarker(result.lng, result.lat);
      this.reverseGeocode(result.lng, result.lat);
    },
    loadMoreResults: function loadMoreResults() {
      if (this.loadingMore || !this.hasMoreResults || !this.currentSearchKeyword) return;
      this.loadingMore = true;
      this.currentPage += 1;
      this.performSearch(this.currentSearchKeyword);
    },
    handleLocationClick: function handleLocationClick() {
      var _this14 = this;
      if (!window.LBS || !window.LBS.WebComponent || !window.LBS.WebComponent.Geolocation) {
        this.$message.warning('定位组件未加载');
        return;
      }
      if (!this.geolocationInstance) {
        this.geolocationInstance = new window.LBS.WebComponent.Geolocation({
          key: process.env.VUE_APP_TENCENT_MAP_KEY,
          referer: process.env.VUE_APP_TENCENT_MAP_REFERER
        });
      }
      this.$message.info('正在定位中...');
      this.geolocationInstance.getLocation(function (result) {
        var lng = result.lng;
        var lat = result.lat;
        if (!_this14.tencentMap) return;
        _this14.tencentMap.setCenter(new TMap.LatLng(lat, lng));
        _this14.tencentMap.setZoom(15);
        _this14.selectedLng = Number(lng).toFixed(6);
        _this14.selectedLat = Number(lat).toFixed(6);
        _this14.addMarker(lng, lat);
        _this14.reverseGeocode(lng, lat);
        _this14.$message.success('定位成功');
      }, function (error) {
        _this14.$message.warning("\u5B9A\u4F4D\u5931\u8D25\uFF1A".concat(error.message || '未知错误'));
      }, {
        timeout: 10000,
        highAccuracy: true,
        maximumAge: 60000
      });
    }
  }
};